import { render, staticRenderFns } from "./end.vue?vue&type=template&id=7d87f3bc"
import script from "./end.vue?vue&type=script&lang=js"
export * from "./end.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports